import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-about">
            <div className="footer-logo">
              <img
                src="/images/logo.jpg"
                alt="Signature Embedded Systems - Innovation in Every Trace"
                className="footer-logo-image"
              />
            </div>
            <p>
              Providing innovative embedded solutions for tomorrow's challenges.
              We specialize in firmware development, hardware design, and IoT solutions.
            </p>
            <div className="social-links">
              <a href="https://linkedin.com/company/signatureesys" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="https://twitter.com/signatureesys" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="https://facebook.com/signatureesys" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-services">
            <h4>Our Services</h4>
            <ul>
              <li><Link to="/services">Firmware Development</Link></li>
              <li><Link to="/services">Hardware Design</Link></li>
              <li><Link to="/services">PCB Design</Link></li>
              <li><Link to="/services">IoT Solutions</Link></li>
              <li><Link to="/services">Embedded Linux</Link></li>
              <li><Link to="/services">Product Development</Link></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Contact Info</h4>
            <ul>
              <li>
                <MapPin size={18} />
                <span>Tech Park, HITEC City<br />Hyderabad, Telangana 500081</span>
              </li>
              <li>
                <Phone size={18} />
                <a href="tel:+919985784340">+91-9985784340</a>
              </li>
              <li>
                <Mail size={18} />
                <a href="mailto:info@signatureesys.com">info@signatureesys.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Signature Embedded Systems - INNOVATION IN EVERY TRACE. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
